/* ============================================================
   Eiferer Cart Drawer — AJAX add-to-cart + slide-out drawer
   Degrades gracefully: if fetch fails, falls back to /cart.
   ============================================================ */
(function () {
  var THRESHOLD = window.EIF_FREE_SHIP_THRESHOLD || 0; // in cents
  var drawer = document.getElementById('eifCartDrawer');

  function $(id) { return document.getElementById(id); }

  function money(cents) {
    var v = (Math.round(cents) / 100).toFixed(2).split('.');
    v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'R' + v.join('.');
  }

  function open() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderShip(total) {
    var wrap = $('eifDrawerShip');
    if (!wrap) return;
    if (!THRESHOLD || THRESHOLD <= 0) { wrap.hidden = true; return; }
    wrap.hidden = false;
    var msg = $('eifDrawerShipMsg');
    var fill = $('eifDrawerShipFill');
    if (total >= THRESHOLD) {
      if (msg) { msg.innerHTML = "\u2713 You've unlocked <b>free shipping</b>!"; msg.classList.add('is-qualified'); }
      if (fill) fill.style.width = '100%';
    } else {
      if (msg) { msg.classList.remove('is-qualified'); msg.innerHTML = 'Add <b>' + money(THRESHOLD - total) + '</b> more for <b>free shipping</b>'; }
      if (fill) fill.style.width = Math.round(total / THRESHOLD * 100) + '%';
    }
  }

  function render(cart) {
    // header count bubble(s)
    var counts = document.querySelectorAll('[data-eif-cart-count]');
    Array.prototype.forEach.call(counts, function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    var dCount = $('eifDrawerCount');
    if (dCount) dCount.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';

    var body = $('eifDrawerBody');
    var foot = $('eifDrawerFoot');
    var empty = $('eifDrawerEmpty');

    if (!cart.items || cart.items.length === 0) {
      if (body) body.innerHTML = '';
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;

    var html = '';
    cart.items.forEach(function (item) {
      var img = item.image ? item.image.replace(/(\.(jpg|jpeg|png|webp|gif))(\?|$)/i, '_120x$1$3') : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="eif-di__variant">' + item.variant_title + '</div>' : '';
      html += '<div class="eif-di" data-key="' + item.key + '">'
        +   '<a href="' + item.url + '" class="eif-di__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>'
        +   '<div class="eif-di__main">'
        +     '<a href="' + item.url + '" class="eif-di__title">' + item.product_title + '</a>'
        +     variant
        +     '<div class="eif-di__row">'
        +       '<div class="eif-di__qty">'
        +         '<button type="button" data-eif-dec aria-label="Decrease">\u2212</button>'
        +         '<span>' + item.quantity + '</span>'
        +         '<button type="button" data-eif-inc aria-label="Increase">+</button>'
        +       '</div>'
        +       '<span class="eif-di__price">' + money(item.final_line_price) + '</span>'
        +     '</div>'
        +     '<button type="button" class="eif-di__remove" data-eif-remove>Remove</button>'
        +   '</div>'
        + '</div>';
    });
    if (body) body.innerHTML = html;

    var sub = $('eifDrawerSubtotal');
    if (sub) sub.textContent = money(cart.total_price);

    renderShip(cart.total_price);
  }

  function refresh(openAfter) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); if (openAfter) open(); return cart; })
      .catch(function () { if (openAfter) window.location.href = '/cart'; });
  }

  function addToCart(payload) {
    var isForm = payload instanceof FormData;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: isForm ? { 'Accept': 'application/json' } : { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: isForm ? payload : JSON.stringify(payload)
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
  }

  function change(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); })
      .catch(function () { window.location.href = '/cart'; });
  }

  /* Intercept any product add-to-cart form */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    if (!window.fetch) return; // no fetch -> native submit to /cart
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    addToCart(new FormData(form))
      .then(function () { return refresh(true); })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  /* Delegated clicks: open / close / quick-add / drawer qty */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var qa = t.closest('[data-eif-quick-add]');
    if (qa) {
      e.preventDefault();
      var id = qa.getAttribute('data-variant-id');
      if (!id) { window.location.href = qa.getAttribute('data-url') || '/cart'; return; }
      qa.classList.add('is-loading');
      addToCart({ id: id, quantity: 1 })
        .then(function () { return refresh(true); })
        .catch(function () { window.location.href = qa.getAttribute('data-url') || '/cart'; })
        .then(function () { qa.classList.remove('is-loading'); });
      return;
    }

    if (t.closest('[data-eif-cart-open]')) { e.preventDefault(); refresh(true); return; }
    if (t.closest('[data-eif-cart-close]')) { e.preventDefault(); close(); return; }

    var di = t.closest('.eif-di');
    if (di) {
      var key = di.getAttribute('data-key');
      var span = di.querySelector('.eif-di__qty span');
      var cur = parseInt(span ? span.textContent : '1', 10) || 1;
      if (t.closest('[data-eif-inc]')) change(key, cur + 1);
      else if (t.closest('[data-eif-dec]')) change(key, Math.max(0, cur - 1));
      else if (t.closest('[data-eif-remove]')) change(key, 0);
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  document.addEventListener('DOMContentLoaded', function () { refresh(false); });

  window.EifCart = { open: open, close: close, refresh: refresh };
})();
